export default __webpack_public_path__ + "122ad17c7d7c1655a39e6f0d86f3a663.png";